/**
 * Logical operators for combining where groups.
 * Currently supports AND and OR operations.
 */
export type LogicalOperator = "AND" | "OR";

/**
 * Type guard for LogicalOperator.
 *
 * @param obj - Value to test
 * @returns True when obj is a valid LogicalOperator
 */
export const isLogicalOperator = (obj: unknown): obj is LogicalOperator => {
  return typeof obj === "string" && ["AND", "OR"].includes(obj);
};
